/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The DrillAnswerResultVo model module.
   * @module drill/model/DrillAnswerResultVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DrillAnswerResultVo</code>.
   * @alias module:drill/model/DrillAnswerResultVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>DrillAnswerResultVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DrillAnswerResultVo} obj Optional instance to populate.
   * @return {module:drill/model/DrillAnswerResultVo} The populated <code>DrillAnswerResultVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'drillId')) {
        obj['drillId'] = ApiClient.convertToType(data['drillId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'score')) {
        obj['score'] = ApiClient.convertToType(data['score'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'scoreLevel')) {
        obj['scoreLevel'] = ApiClient.convertToType(data['scoreLevel'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * drill id
   * @member {Integer} drillId
   */
  exports.prototype['drillId'] = undefined;
  /**
   * 用户得分 满分100分
   * @member {Integer} score
   */
  exports.prototype['score'] = undefined;
  /**
   * 0 未做，1红色，2黄色，3绿色
   * @member {Integer} scoreLevel
   */
  exports.prototype['scoreLevel'] = undefined;



  export default exports;
;


